module.exports = __webpack_public_path__ + "img/3-5.5d73fda7.jpg";